import { getBaseAPIUrl } from './apiUtils';
import axiosInstance from './axiosConfig';

export function logError(data) {
  return axiosInstance.request({ method: 'post', url: `${getBaseAPIUrl()}/logs`, data: data });
}
